import { Component, OnInit, ViewChild } from '@angular/core'
import { FormBuilder } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { StatisticsAntiCounterfeitingService } from '../statistics-anti-counterfeiting/services/statistics-anti-counterfeiting.service';
import { ModalDirective } from 'ngx-bootstrap';
import { BatchService } from '../../qrcode/batchstamp/batch.service';
import { ExportService } from 'app/common/services/Export.service';
import { UtilityService } from '../../../../common/services/Utility.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'app-statistics-anti-counterfeiting',
  templateUrl: './statistics-anti-counterfeiting.component.html',
  styleUrls: ['./statistics-anti-counterfeiting.component.css'],
  providers: [StatisticsAntiCounterfeitingService]
})
export class StatisticsAntiCounterfeitingComponent implements OnInit {
  @ViewChild('detailAgency') detailAgency: ModalDirective;
  @ViewChild('stampLock') stampLock: ModalDirective;
  @ViewChild('stampUnLock') stampUnLock: ModalDirective;
  @ViewChild('logScanStamp') logScanStamp: ModalDirective;
  public params_search_account_icheck: string;
  public no_product = 'assets/images/no_product.png';
  /** Thống kê**/
  public dataOverview: {
    total_stamps_in_service: 0,
    count_stamp_scan: 0,
    count_stamp_warning: 0,
    count_scan: 0,
    count_warning: 0,
  };
  public messageExport = '';
  /** Danh sách tem có cảnh báo **/
  public formStampWarning = this.fb.group([]);
  public dataStampWarning = [];
  public pageIndexStampWarning = 1;
  public pageSizeStampWarning = 10;
  public totalStampWarning = 0;
  public loadingStampWarning = false;
  public queryStampWarning = {
    page: undefined,
    pageSize: undefined,
    product_ids: undefined,
    serial: undefined,
    batch_ids: undefined
  };
  public noteLockStamp: string = ''
  public itemDetailStampWarning: any;

  public pageIndexDetailStampWarning = 1;
  public pageSizeDetailStampWarning = 10;
  public loading_detail_stamp_warning = false;
  public dataDetailStampWarning = [];
  public totalDetailStampWarning = 0;
  public queryDetailStampWarning = {
    page: undefined,
    size: undefined
  }
  public idDetailAgencyProduct: any;
  public nameDetailAgency: any;
  /** Cảnh báo chống giả theo khu vực **/
  public totalAntiCouterWarningArea = 0;
  public dataAntiCouterWarningArea = [];
  public dataAntiCouterWarningAreaFilter = [];
  /** Trạng thái quét tem theo sản phẩm **/
  public dataScanStampProduct = [];
  public pageIndexScanStampProduct = 1;
  public pageSizeScanStampProduct = 10;
  public totalScanStampProduct = 0;
  public loadingScanStampProduct = false;
  public queryScanStampProduct = {
    page: undefined,
    size: undefined,
    product_ids: undefined
  };
  public formScanStampProduct = this.fb.group([]);
  /** Trạng thái quét tem theo lô tem **/
  public dataScanStamp = [];
  public pageIndexDataScanStamp = 1;
  public pageSizeDataScanStamp = 10;
  public totalDataScanStamp = 0;
  public loadingDataScanStamp = false;
  public queryDataScanStamp = {
    page: undefined,
    size: undefined,
    batch_ids: undefined
  };
  public formDataScanStamp = this.fb.group([]);

  constructor(
    private statisticsAntiCounterfeitingService: StatisticsAntiCounterfeitingService,
    private exportService: ExportService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private batchService: BatchService,
    private translateService: TranslateService
  ) {
  }


  createFormFilter() {
    this.formStampWarning = this.fb.group({
      serial: [null],
    });
  }

  async ngOnInit() {
    $('#inputStartAnti').datepicker({ format: 'dd/mm/yyyy' });
    $('#inputEndAnti').datepicker({ format: 'dd/mm/yyyy' });
    this.changeTime();
    this.createFormFilter();
    const that = this;
    /** Tem có cảnh baáo **/
    $('#antiStatisticProduct').select2({
      placeholder: this.translateService.instant('SAN_PHAM'),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/products`,
        headers: {
          authorization: localStorage.getItem('Access-Token'),
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          if (params.term !== undefined) {
            that.params_search_account_icheck = params.term;
          }
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
              // tslint:disable-next-line:object-literal-shorthand
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.products.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $('#antiStatisticStamp').select2({
      placeholder: this.translateService.instant('LO_TEM'),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            console.log('params.term', params.term)
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_child: 0,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_child: 0,
          };
        },
        processResults: function (data) {
          console.log('data.data ', data.data);
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  console.log('tloggggg', {
                    text: item.name,
                    id: item.id,
                  });
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });
    /** Trạng thái quét tem theo sản phẩm **/
    setTimeout(() => {
      $('#scanStampProduct').select2({
        placeholder: this.translateService.instant('SAN_PHAM'),
        allowClear: true,
        ajax: {
          delay: 1000,
          url: `${environment.api_evs}/products`,
          headers: {
            authorization: localStorage.getItem('Access-Token'),
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            if (params.term !== undefined) {
              that.params_search_account_icheck = params.term;
            }
            if (params.term) {
              return {
                name: params.term,
                offset: 0,
                limit: 50,
                // tslint:disable-next-line:object-literal-shorthand
              };
            }
            return {
              offset: 0,
              limit: 50,
            };
          },
          processResults: function (data) {
            return {
              results: data.data.products.map((item) => {
                return {
                  text: item.name,
                  id: item.id,
                };
              }),
            };
          },
        },
      });
    }, 100)
    /** Trạng thái quét theo lô tem **/
    $('#statisticDataScanStamp').select2({
      placeholder: this.translateService.instant('LO_TEM'),
      allowClear: true,
      // minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            console.log('params.term', params.term)
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_child: 0,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_child: 0,
          };
        },
        processResults: function (data) {
          console.log('data.data ', data.data);
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  console.log('tloggggg', {
                    text: item.name,
                    id: item.id,
                  });
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });
    this.getStatisticOverView();
    this.getListStampWarning();
    this.getAntiCounterWarningArea();
    this.getListScanStampProduct();
    this.getListDataScanStamp();
  }

  /** Thông kê **/
  getStatisticOverView() {
    this.statisticsAntiCounterfeitingService.getOverviewAntiCounterfeiting().subscribe((res) => {
      if (res.code == 1) {
        this.dataOverview = res.data
        console.log('this.dataover', this.dataOverview)
      }
    })
  }

  /** Thống kê theo danh sách có tem cảnh báo **/
  searchStampWarning() {
    this.pageIndexStampWarning = 1;
    this.getListStampWarning();
  }

  resetStampWarning() {
    $('#antiStatisticStamp').val('').trigger('change');
    $('#antiStatisticProduct').val('').trigger('change');
    this.formStampWarning.get('serial').setValue('');
    this.getListStampWarning();
  }

  getListStampWarning() {
    this.queryStampWarning.page = this.pageIndexStampWarning;
    this.queryStampWarning.pageSize = this.pageSizeStampWarning;
    this.queryStampWarning.serial = this.formStampWarning.get('serial').value ? this.formStampWarning.get('serial').value : '';
    this.queryStampWarning.batch_ids = $('#antiStatisticStamp').val() ? $('#antiStatisticStamp').val() : '';
    this.queryStampWarning.product_ids = $('#antiStatisticProduct').val() ? $('#antiStatisticProduct').val() : '';
    console.log('111123333', this.queryStampWarning)
    this.statisticsAntiCounterfeitingService.getStampWarning(this.queryStampWarning).subscribe((res) => {
      if (res.code == 1 && res.data) {
        this.totalStampWarning = res.data.pagination.totalElements
        this.dataStampWarning = res.data.items
        console.log('this.dataInventoryProduct', this.totalStampWarning)
      } else {
        this.loadingStampWarning = false;
        this.totalStampWarning = 0;
        this.dataStampWarning = [];
      }
    }, (error) => {
      this.loadingStampWarning = false;
      this.totalStampWarning = 0;
      this.dataStampWarning = [];
      this.toastr.error(error.message, this.translateService.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toastr-bottom-right'
      })
    })
  }

  inputStampWarning(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStampWarning) {
      this.pageIndexStampWarning = page;
      this.getListStampWarning();
    }
  }

  preStampWarning() {
    this.pageIndexStampWarning = this.pageIndexStampWarning - 1;
    this.getListStampWarning();
  }

  lastStampWarning() {
    if (this.pageIndexStampWarning * this.pageSizeStampWarning < this.totalStampWarning) {
      this.pageIndexStampWarning = this.pageIndexStampWarning + 1;
      this.getListStampWarning();
    }
  }

  /** Modal chi tiết đại lý**/
  showModalActionStamp(item: any, type: string) {
    this.itemDetailStampWarning = item;
    console.log(this.itemDetailStampWarning)
    if (type === 'lock') {
      this.stampLock.show();
    } else if (type === 'unlock') {
      this.stampUnLock.show();
    } else {
      this.loadListDetailStampWarning(item.stampData.serial)
      this.logScanStamp.show();
    }
  }

  closeModalActionStamp(type: string) {
    this.noteLockStamp = ''
    if (type === 'lock') {
      this.stampLock.hide();
    } else if (type === 'unlock') {
      this.stampUnLock.hide();
    } else {
      this.logScanStamp.hide();
    }
  }

  submitLockStamp(type: string) {
    const tmp = this.itemDetailStampWarning;

    if (type === 'lock') {
      if (!this.noteLockStamp) {
        this.toastr.warning(this.translateService.instant('LY_DO_KHOA_TEM_KHONG_TRONG'), this.translateService.instant('CANH_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return
      }
      const query = {
        'batch_id': tmp.stampData.batchId,
        'id_start': tmp.stampData.number,
        'id_end': tmp.stampData.number,
        'note': this.noteLockStamp,
        'status': 1
      }
      this.statisticsAntiCounterfeitingService.restoreStamp(query).subscribe((res) => {
        if (res.status == 200) {
          this.toastr.success(this.translateService.instant('YEU_CAU_KHOA_TEM_THANH_CONG'), this.translateService.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.noteLockStamp = '';
          this.closeModalActionStamp('lock')
          this.getListStampWarning()
        } else {
          this.noteLockStamp = '';
          this.closeModalActionStamp('lock')
          this.getListStampWarning()
          this.toastr.warning(res.message, this.translateService.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-bottom-right'
          })
        }
      }, (error) => {
        this.noteLockStamp = '';
        this.closeModalActionStamp('lock')
        this.getListStampWarning()
        this.toastr.error(error.message, this.translateService.instant('CANH_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      })
    } else {
      const query = {
        'batch_id': tmp.stampData.batchId,
        'id_start': tmp.stampData.number,
        'id_end': tmp.stampData.number,
        'status': 0
      }
      this.statisticsAntiCounterfeitingService.restoreStamp(query).subscribe((res) => {
        if (res.status == 200) {
          this.toastr.success(this.translateService.instant('YEU_CAU_MO_KHOA_TEM_THANH_CONG'), this.translateService.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.noteLockStamp = '';
          this.closeModalActionStamp('unlock')
          this.getListStampWarning()
        } else {
          this.noteLockStamp = '';
          this.closeModalActionStamp('unlock')
          this.getListStampWarning()
          this.toastr.warning(res.message, this.translateService.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-bottom-right'
          })
        }
      }, (error) => {
        this.noteLockStamp = '';
        this.closeModalActionStamp('unlock')
        this.getListStampWarning()
        this.toastr.error(error.message, this.translateService.instant('CANH_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      })
    }
  }

  loadListDetailStampWarning(serial: any) {
    this.loading_detail_stamp_warning = true;
    this.queryDetailStampWarning.page = this.pageIndexDetailStampWarning;
    this.queryDetailStampWarning.size = this.pageSizeDetailStampWarning;
    this.statisticsAntiCounterfeitingService
      .getListDetailStampWarning(this.queryDetailStampWarning, serial)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.dataDetailStampWarning = res.data.items;
            this.dataDetailStampWarning.map((res) => {
              res.timeScan = moment(res.timeScan).format('HH:mm:ss DD/MM/YYYY')
              if (res.customer != null) {
                if (res.customer.address) {
                  if (res.customer.districtName && res.customer.cityName) {
                    res['log_scan'] = res.customer.address + ',' + res.customer.districtName + ',' + res.customer.cityName
                  } else if (!res.customer.districtName && res.customer.cityName) {
                    res['log_scan'] = res.customer.address + ',' + res.customer.cityName
                  } else if (res.customer.districtName && !res.customer.cityName) {
                    res['log_scan'] = res.customer.address + ',' + res.customer.districtName
                  } else {
                    res['log_scan'] = res.customer.address
                  }
                } else {
                  if (res.customer.districtName && res.customer.cityName) {
                    res['log_scan'] = res.customer.districtName + ',' + res.customer.cityName
                  } else if (!res.customer.districtName && res.customer.cityName) {
                    res['log_scan'] = res.customer.cityName
                  } else if (res.customer.districtName && !res.customer.cityName) {
                    res['log_scan'] = res.customer.districtName
                  }
                }
              }
            })
            console.log('this.dataDetailStampWarning', this.dataDetailStampWarning)
            this.totalDetailStampWarning = res.data.pagination.totalElements;
            this.loading_detail_stamp_warning = false;
            return;
          } else {
            this.dataDetailStampWarning = [];
            this.totalDetailStampWarning = 0;
            this.loading_detail_stamp_warning = false;
          }
        },
        (error) => {
          this.dataDetailStampWarning = [];
          this.totalDetailStampWarning = 0;
          this.loading_detail_stamp_warning = false;
        }
      );
  }

  inputDetailStampWarning(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexDetailStampWarning) {
      this.pageIndexDetailStampWarning = page;
      this.loadListDetailStampWarning(this.itemDetailStampWarning.stampData.serial);
    }
  }

  preDetailStampWarning() {
    this.pageIndexDetailStampWarning = this.pageIndexDetailStampWarning - 1;
    this.loadListDetailStampWarning(this.itemDetailStampWarning.stampData.serial);
  }

  lastDetailStampWarning() {
    if (this.pageIndexDetailStampWarning * this.pageSizeDetailStampWarning < this.totalDetailStampWarning) {
      this.pageIndexDetailStampWarning = this.pageIndexDetailStampWarning + 1;
      this.loadListDetailStampWarning(this.itemDetailStampWarning.stampData.serial);
    }
  }

  /** End Modal chi tiết đại lý**/

  /** Cảnh báo chống giả theo khu vực **/
  getAntiCounterWarningArea() {
    const datafilter = [];
    this.statisticsAntiCounterfeitingService.getAntiCounterWarningArea().subscribe((res) => {
      console.log('this.warning', res)
      if (res.code == 1) {
        this.dataAntiCouterWarningArea = res.data.items
        this.dataAntiCouterWarningArea.map((val) => {
          this.totalAntiCouterWarningArea += Number(val.count)
        })
        this.dataAntiCouterWarningArea.map((item) => {
          item['percent'] = Number(((item.count / this.totalAntiCouterWarningArea) * 100).toFixed());
          datafilter.push(item)
        })
        this.dataAntiCouterWarningAreaFilter = datafilter
        console.log('dataWarningFilter', this.dataAntiCouterWarningAreaFilter)
      }
    })
  }

  /** Trạng thái quét tem theo sản phẩm **/
  searchScanStampProduct() {
    this.pageIndexScanStampProduct = 1;
    this.getListScanStampProduct();
  }

  resetScanStampProduct() {
    $('#scanStampProduct').val('').trigger('change');
    this.getListScanStampProduct();
  }

  getListScanStampProduct() {
    this.queryScanStampProduct.page = this.pageIndexScanStampProduct;
    this.queryScanStampProduct.size = this.pageSizeScanStampProduct;
    console.log('this.queryScanStampProduct', typeof $('#scanStampProduct').val())
    this.queryScanStampProduct.product_ids = $('#scanStampProduct').val() ? $('#scanStampProduct').val().toString() : '';
    console.log('this.queryScanStampProduct', this.queryScanStampProduct)
    this.statisticsAntiCounterfeitingService.getScanStampProduct(this.queryScanStampProduct).subscribe((res) => {
      if (res.code == 1 && res.data) {
        this.totalScanStampProduct = res.data.pagination.totalElements
        this.dataScanStampProduct = res.data.items
      } else {
        this.loadingScanStampProduct = false;
        this.totalScanStampProduct = 0;
        this.dataScanStampProduct = [];
      }
    }, (error) => {
      this.loadingScanStampProduct = false;
      this.totalScanStampProduct = 0;
      this.dataScanStampProduct = [];
      this.toastr.error(error.message, this.translateService.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toastr-bottom-right'
      })
    })
  }

  inputScanStampProduct(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexScanStampProduct) {
      this.pageIndexScanStampProduct = page;
      this.getListScanStampProduct();
    }
  }

  preScanStampProduct() {
    this.pageIndexScanStampProduct = this.pageIndexScanStampProduct - 1;
    this.getListScanStampProduct();
  }

  lastScanStampProduct() {
    if (this.pageIndexScanStampProduct * this.pageSizeScanStampProduct < this.totalScanStampProduct) {
      this.pageIndexScanStampProduct = this.pageIndexScanStampProduct + 1;
      this.getListScanStampProduct();
    }
  }

  /** Trạng thái quét tem theo lô tem **/
  searchDataScanStamp() {
    this.pageIndexDataScanStamp = 1;
    this.getListDataScanStamp();
  }

  resetDataScanStamp() {
    $('#statisticDataScanStamp').val('').trigger('change');
    this.getListDataScanStamp();
  }

  getListDataScanStamp() {
    this.queryDataScanStamp.page = this.pageIndexDataScanStamp;
    this.queryDataScanStamp.size = this.pageSizeDataScanStamp;
    this.queryDataScanStamp.batch_ids = $('#statisticDataScanStamp').val() ? $('#statisticDataScanStamp').val().toString() : '';
    this.statisticsAntiCounterfeitingService.getDataScanStamp(this.queryDataScanStamp).subscribe((res) => {
      if (res.code == 1 && res.data) {
        this.totalDataScanStamp = res.data.pagination.totalElements
        this.dataScanStamp = res.data.items
      } else {
        this.loadingDataScanStamp = false;
        this.totalDataScanStamp = 0;
        this.dataScanStamp = [];
      }
    }, (error) => {
      this.loadingDataScanStamp = false;
      this.totalDataScanStamp = 0;
      this.dataScanStamp = [];
      this.toastr.error(error.message, this.translateService.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toastr-bottom-right'
      })
    })
  }

  inputDataScanStamp(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexDataScanStamp) {
      this.pageIndexDataScanStamp = page;
      this.getListDataScanStamp();
    }
  }

  preDataScanStamp() {
    this.pageIndexDataScanStamp = this.pageIndexDataScanStamp - 1;
    this.getListDataScanStamp();
  }

  lastDataScanStamp() {
    if (this.pageIndexDataScanStamp * this.pageSizeDataScanStamp < this.totalDataScanStamp) {
      this.pageIndexDataScanStamp = this.pageIndexDataScanStamp + 1;
      this.getListDataScanStamp();
    }
  }

  /** Biểu đồ  **/
  // tslint:disable-next-line:member-ordering
  scanStatusLocation: any = [];
  allLocation: any = '';

  sort(arr) {
    if (arr.length) {
      let _arr: any = [];
      for (let i = 0; i < arr.length; i++) {
        for (let j = arr.length - 1; j >= 0; j--) {
          if (arr[i].count < arr[j].count) {
            _arr.push(arr[i]);
            _arr.push(arr[j]);
            arr[i] = _arr[1];
            arr[j] = _arr[0];
            _arr = [];
          }
        }
      }
      const list: any = [];
      list.push(arr[arr.length - 1]);
      let h = 0;
      const leng = arr.length - 1;
      while (h < leng) {
        list.push(arr[h]);
        h++;
      }
      return list;
    }
    return [];
  }

  // tslint:disable-next-line:member-ordering
  colors: any = [
    {
      id: 1,
      color: '#061178',
    },
    {
      id: 2,
      color: '#926dde',
    },
    {
      id: 3,
      color: '#7dd3ae',
    },
    {
      id: 4,
      color: '#9bee48',
    },
    {
      id: 5,
      color: '#70726d',
    },
    {
      id: 6,
      color: '#df0f57',
    },
    {
      id: 7,
      color: '#317187',
    },
    {
      id: 8,
      color: '#d7cbb6',
    },
  ];

  getScanStatus(startDateMM: any, endDateMM: any, days, startDate, endDate) {
    const data: any = {};
    data.from = startDateMM;
    data.to = endDateMM;
    const listCount: any = [];
    const listWarning: any = [];
    const listDays: any = [];
    let dayCount = new Date();
    this.statisticsAntiCounterfeitingService.getDashboardScanNew(data).subscribe((res) => {
      console.log('111111', res)
      const item = {};
      const data2 = res.data
      console.log('res.data', data2)
      const actives = [];
      const warnings = [];

      // tslint:disable-next-line:forin
      for (const key in data2) {
        const objActive = {
          date: undefined,
          count: undefined
        };
        objActive.date = key;
        objActive.count = data2[key].totalActiveScan;
        actives.push(objActive);

        const objWarning = {
          date: undefined,
          count: undefined
        };
        objWarning.date = key;
        objWarning.count = data2[key].totalWarningScan;
        warnings.push(objWarning);
      }
      data2.scan = actives;
      data2.warning = warnings;
      console.log('res.dataaaaaaaa', data2)
      const listDataStatus = data2.scan
      const listDataWarning = data2.warning;
      console.log(data2);
      for (let i = days; i >= 0; i--) {
        item['day'] = UtilityService.getFormattedDate(
          moment(endDate).subtract(i, 'd')['_d']
        );
        item['count'] = 0;
        item['warning'] = 0;
        for (let j = 0; j < listDataStatus.length; j++) {
          if (listDataStatus[j]['date'] === item['day']) {
            item['count'] = listDataStatus[j]['count'];
          }
        }
        for (let j = 0; j < listDataWarning.length; j++) {
          if (listDataWarning[j]['date'] === item['day']) {
            item['warning'] = listDataWarning[j]['count'];
          }
        }
        listCount.push(item['count']);
        listWarning.push(item['warning']);
        dayCount = new Date(item['day']);
        listDays.push(dayCount.getDate());
      }
      console.log('listCount, dayCount', listCount, dayCount)
      if ($('#statusScanAnti').length > 0) {
        console.log('$(\'.ct-series-a .ct-line\')', $('.ct-series-a .ct-line'))
        $('.ct-series-a .ct-line').css('stroke: red');
        // tslint:disable-next-line:no-unused-expression
        const chart = new Chartist.Line('#statusScanAnti',
          {
            labels: listDays,
            series: [listWarning, listCount]
          },
          {
            height: '300px',
            fullWidth: true,
            chartPadding: {},
            low: 0,
            plugins: [Chartist.plugins.tooltip()],
            axisY: {
              onlyInteger: true,
            },
          },
        );
      }
    });
  }

  changeTime() {
    let startDate: any = '';
    let endDate: any = '';
    startDate = moment().day(-30);
    endDate = moment();
    console.log('ádasdasd1111', startDate, endDate)
    $('#inputStartAnti').datepicker('update', startDate._d);
    $('#inputEndAnti').datepicker('update', endDate._d);
    this.filterChart()
  }

  filterChart() {
    let startDate: any = '';
    let endDate: any = '';
    if ($('#inputStartAnti').val()) {
      startDate = moment($('#inputStartAnti').val(), ['DD/MM/YYYY'])['_d'];
    }
    if ($('#inputEndAnti').val()) {
      endDate = moment($('#inputEndAnti').val(), ['DD/MM/YYYY'])['_d'];
    }
    const days = parseInt(
      ((endDate - startDate) / (24 * 3600 * 1000)).toFixed(0)
    );
    console.log(2, endDate, startDate, days)

    const startSateFM = UtilityService.getFormattedDateNew(startDate);
    const endSateFM = UtilityService.getFormattedDateNew(endDate);
    console.log('filterererer', startDate, endDate, startSateFM, endSateFM)
    this.getScanStatus(startSateFM, endSateFM, days, startDate, endDate);
  }

  loadMoreUserLogScan(index) {
    $(`.more-user-log-scan-${index}`).toggle();
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/statistics-anti-counterfeiting/statistics-anti-counterfeiting.component.ts